import { createContext } from 'react';

import { getAppEnvironmentSettings } from './get-app-environment-settings';

export const EnvironmentContext = createContext(getAppEnvironmentSettings());
